module.exports = __webpack_public_path__ + "static/media/farewell.42719f72.svg";